import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { VGSCardInfo } from 'apps/public-portal/src/app/payment-integrations/base/models';
import {
    PaymentIntegrationFieldValue,
} from 'apps/public-portal/src/app/payment-integrations/base/components/payment-integration-form-field/payment-integration-form-field.component';
import { VgsCollectBase } from './vgs-collect-base';

@Component({
    selector: 'app-vgs-collect-credit',
    templateUrl: './vgs-collect-credit.component.html',
    styleUrls: ['./vgs-collect.component.scss'],
    host: {
        class: 'vgs-collect payment-method-details payment-method-details--credit'
    },
})
export class VgsCollectCreditComponent extends VgsCollectBase {
    @Input() public CC_FIELDS: {
        ccname: string,
        ccnumber: string,
        ccexp: string,
        cvv: string
    };

    protected initFormControls(): void {
        Object.keys(this.CC_FIELDS).filter(f => f !== 'ccname').forEach(name => {
            this.formGroup.addControl(name, new UntypedFormControl(
                new PaymentIntegrationFieldValue(null, '', name, this.CC_FIELDS[name])
            ));
        });
        this.formGroup.addControl(this.CC_FIELDS.ccname, new UntypedFormControl(this.paymentMethodData.billingInfo.fullName));

        this._formChangeSubscription = this.formGroup.valueChanges.subscribe(value => {
            this.paymentMethodData.billingInfo.fullName = value[this.CC_FIELDS.ccname];
        });
    }

    protected initVGSFields(): void {
        this._vgsCollectForm.field('#vgsCCNumber', {
            type: 'card-number',
            name: 'cardNumber',
            placeholder: '0000000000000000',
            showCardIcon: true,
            validations: ['required', 'validCardNumber'],
        });
        this._vgsCollectForm.field('#vgsCVC', {
            type: 'card-security-code',
            name: 'cardCvc',
            placeholder: '000',
            showCardIcon: true,
            validations: ['required', 'validCardSecurityCode'],
        });
        this._vgsCollectForm.field('#vgsCCExp', {
            type: 'card-expiration-date',
            name: 'cardExp',
            placeholder: 'MM / YY',
            validations: ['required', 'validCardExpirationDate'],
        });
    }

    protected mapVGSResponse(data: VGSCardInfo): void {
        data.cardExp = data.cardExp.replace(/\s/g, '');

        this.paymentMethodData.cardNumber = data.cardNumber;
        this.paymentMethodData.cardExpiry = data.cardExp;
        this.paymentMethodData.cvvToken = data.cardCvc;

        this.formGroup.controls.ccnumber.setValue(new PaymentIntegrationFieldValue(data.cardNumber, ''));
        this.formGroup.controls.ccexp.setValue(new PaymentIntegrationFieldValue(data.cardExp, ''));
        this.formGroup.controls.cvv.setValue(new PaymentIntegrationFieldValue(data.cardCvc, ''));
    }

    protected getValidationFieldMappings(): { formControl: string, vgsField: string, label: string }[] {
        return [
            { formControl: 'cvv', vgsField: 'cardCvc', label: this.CC_FIELDS.cvv },
            { formControl: 'ccnumber', vgsField: 'cardNumber', label: this.CC_FIELDS.ccnumber },
            { formControl: 'ccexp', vgsField: 'cardExp', label: this.CC_FIELDS.ccexp },
        ];
    }

    public generateAdditionalErrors(): { [key: string]: string } {
        const errors: { [key: string]: string } = {};
        if (this.formGroup.controls.ccnumber?.value?.error) errors.ccnumber = this.formGroup.controls.ccnumber.value.error;
        if (this.formGroup.controls.cvv?.value?.error) errors.cvv = this.formGroup.controls.cvv.value.error;
        if (this.formGroup.controls.ccexp?.value?.error) errors.ccexp = this.formGroup.controls.ccexp.value.error;
        return errors;
    }
}
